import request from '@/utils/request'

// 根据条件获取商品
export function getProducts (filter) {
  return request.get('api/admin/products', filter)
}

// 获取所有商品信息
export function getProductsAll () {
  return request.get('api/admin/products/all')
}

//添加商品
export function saveProduct (product) {
  return request.post('/api/admin/products', product)
}

// 修改商品
export function updateProduct (product) {
  return request.put('/api/admin/products/', product)
}

// 删除商品
export function deleteProduct (id) {
  return request.delete('/api/admin/products/', id)
}

// 对外商城商品展示
export function showProducts (filter) {
  return request.post('api/getproducts', filter)
}

// 购买地址
export function buyProduct (filter) {
  return request.post('api/unifiedorderbyh5', filter)
  // return request.post('api/unifiedorder', filter)
}



// WEBPACK FOOTER //
// ./src/api/products.js